import ChatScreen from 'features/chat/ChatScreen/ChatScreen';
import ChatContextProvider from 'features/chat/providers/ChatContextProvider';
import React from 'react';

export default function ChatScreenPage() {
  return (
    <ChatContextProvider>
      <ChatScreen />
    </ChatContextProvider>
  );
}
